import { DRAGGABLE_BLOCK_MENU_CLASSNAME } from './constants'

export function isOnMenu(element: HTMLElement) {
  return !!element.closest(`.${DRAGGABLE_BLOCK_MENU_CLASSNAME}`)
}
